/**
 * TanStack Query key for resolved lip / card attribution (initial + optional
 * avatar) for a single internal account id. Many blocks with the same
 * `createdBy` share one cache entry.
 */
export function accountAttributionQueryKey(accountId) {
    return ["account.attribution", accountId];
}
